import { useMemo, useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { getGatekeeperApiClient } from 'lib/SplashApiClient/subclients/GatekeeperApiClient';
import { GATEKEEPER_STATES } from '../constants';
import { useOnGatekeeperRequestError } from './useOnGatekeeperRequestError';

export const useGatekeeperPing = ({ heartbeatId, enabled, refetchInterval, guestAccessHash }) => {
    const gatekeeperApiClient = useMemo(() => getGatekeeperApiClient({ guestAccessHash }), [guestAccessHash]);
    const [gateStatus, setGateStatus] = useState(GATEKEEPER_STATES.NOT_INITIALIZED);

    const pingHeartbeat = useQuery('heartbeat.status', () => gatekeeperApiClient.ping({ heartbeatId }), {
        refetchIntervalInBackground: true,
        retry: false,
        enabled: enabled && refetchInterval > 0,
        refetchInterval,
    });

    useOnGatekeeperRequestError({
        statusCode: pingHeartbeat?.error?.response?.status,
        onGatesClosed: () => setGateStatus(GATEKEEPER_STATES.CLOSED),
        onGatesOpened: () => setGateStatus(GATEKEEPER_STATES.OPENED),
    });

    useEffect(() => {
        if (pingHeartbeat?.status === 'success') {
            setGateStatus(GATEKEEPER_STATES.OPENED);
        }
    }, [pingHeartbeat?.status]);

    return useMemo(() => ({ pingGateStatus: gateStatus }), [gateStatus]);
};
